module.exports = __webpack_public_path__ + "img/ios.22b6e6e5.png";